import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromUnit from '../reducers';
import { Observable } from 'rxjs';
import { Unit } from '../models/unit';
import * as unitActions from '../actions/unit';

@Component({
  selector: 'mj-unit-settings-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div fxFlex fxLayout="row" class="settings">
      <div fxFlex="20">
        <mj-unit-tree
          (selectUnit)="selectUnit($event)"
          [treeData]="units$ | async"
          [unit]="selectedUnit$ | async"
        ></mj-unit-tree>
      </div>
      <div fxFlex="80">
        <mj-unit-settings
          (update)="updateHandler($event)"
          (delete)="deleteHandler($event)"
          [unit]="selectedUnit$ | async"
          [units]="units$ | async"
        ></mj-unit-settings>
      </div>
    </div>
  `,
  styles: [
    `
      mj-unit-settings {
        display: flex;
        background-color: #fff;
      }
    `,
  ],
})
export class UnitSettingsViewComponent {
  id: number;
  selectedUnit$: Observable<Unit>;
  units$: Observable<Unit[]>;

  constructor(private store: Store<fromUnit.State>) {
    this.selectedUnit$ = this.store.select(fromUnit.selectUnit);
    this.units$ = this.store.select(fromUnit.selectUnits);
  }

  selectUnit($event: { unit: Unit; refresh: boolean }) {
    if ($event.refresh) {
      this.store.dispatch(new unitActions.LoadUnit({ unit: $event.unit }));
      this.store.dispatch(
        new unitActions.LoadUnitUsers({ id: $event.unit.id })
      );
    }
  }

  updateHandler($event: { unit: Unit }) {
    this.store.dispatch(new unitActions.UpdateUnit($event));
  }

  deleteHandler($event: number) {
    this.store.dispatch(new unitActions.DeleteUnit({ unitId: $event }));
  }
}
